import { Input as InputAnt, type InputProps } from 'antd';
import { type ChangeEvent, type KeyboardEvent, useCallback } from 'react';

import { usePhoneMask } from 'src/components/base';

function isForMobilePhone(str: string): boolean {
  return /^[\d]+$/.test(str);
}

function onKeyPressHandler(event: KeyboardEvent<HTMLInputElement>): void {
  if (!isForMobilePhone(event.key)) {
    event.preventDefault();
  }
}

export function PhoneInput({ onChange, value, ...rest }: Readonly<InputProps>) {
  const { getMaskedPhone, getRealPhone, maskedMaxPhoneLength } = usePhoneMask(value as string | null);

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        const appliedMask = {
          ...event,

          target: {
            ...event.target,

            value: getRealPhone(event.target.value),
          },
        };

        onChange(appliedMask);
      }
    },
    [onChange, getRealPhone]
  );

  return (
    <InputAnt
      {...rest}
      value={getMaskedPhone}
      onChange={handleChange}
      onKeyPress={onKeyPressHandler}
      maxLength={maskedMaxPhoneLength}
      allowClear={true}
    />
  );
}
